export const meta = {
  title: '员工与角色:对的按钮,交给对的手',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'billing'],
};

全体员工都能用后台——但洗车工不需要看您的账单页,收银员也不必改目录。四种角色把这事理顺。管理入口在**员工**页面,而这个页面本身只有店主和经理能看到。

## 四种角色

- **店主**——完全访问:账单、员工、每一个页面。这是您:角色在注册时确定,不能在员工页面授予或修改。
- **经理**——得力副手:设置、目录、报表、调整队伍顺序、发放代金券、管理员工。除了不是店主,几乎无所不能。
- **收银员**——柜台:在 POS 收款、创建和推进单子、查询顾客、看报表。不能调整队伍顺序,碰不到钱的设置,管不了员工。
- **洗车工**——洗车位:只有排队看板——推进单子状态。洗车工不能调整队伍顺序(底层有一个按门店放开的开关,但后台的切换控件还没做)。没有 POS。

在幕后,每种角色都在数据层强制执行——谁越权去戳一个 URL,会被服务器直接拒绝,而不只是藏起按钮。

## 邀请一个人

员工页面的邀请卡只要三样:对方的**马来西亚手机号**(必填)、可选的显示名,和一个角色——**经理**、**收银员**或**洗车工**,收银员为预选。

流程就这么多。没有邮件,没有邀请链接,不需要对方接受:提交即刻挂上角色。手机号是新的,账号当场创建——那个人第一次登录时用手机一次性验证码(OTP)即可。已经在用这个平台的号码,角色在下次刷新时生效。

## 员工属于门店

邀请落在您当前查看的门店——提交前看一眼门店切换器。有人跨两家门店干活?在每家门店各邀请一次同一个手机号。

## 换角色与送人走

每行员工都有角色下拉——改了之后在对方下次刷新时生效。**停用**收回访问权限,同时保留记录(谁添加的、何时)供您查账;**重新启用**把人请回来。有两行是故意锁死的:店主那行,和您自己那行——免得有人不小心把自己锁在自家洗车店外面。

## 员工功能还没有的

没有席位上限——业务需要多少员工就邀请多少,不加钱。同样还没做,免得您到处找:共用平板的 PIN 快捷登录、排班表、打卡记录。员工用手机 OTP 登录,上面这四种角色就是全部权限模型。
